import { ReactComponent as AnycoinLogo } from "assets/exchanges/anycoin-logo-original.svg";
import { ReactComponent as BinanceLogo } from "assets/exchanges/binance-logo-original.svg";
import { ReactComponent as BitstampLogo } from "assets/exchanges/bitstamp-logo-original.svg";
import { ReactComponent as BybitEuLogo } from "assets/exchanges/bybiteu-logo-original.svg";
import { ReactComponent as CoinbaseproLogo } from "assets/exchanges/coinbasepro-logo-original.svg";
import { ReactComponent as CoinmateLogo } from "assets/exchanges/coinmate-logo-original.svg";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { ExchangeType } from "types/enums";

interface Props extends React.SVGProps<SVGSVGElement> {
  type: ExchangeType;
}

const ExchangeIcon = ({ type, ...props }: Props) => {
  const { colors } = useMUIThemeModeContext();

  const getIcon = () => {
    switch (type) {
      case ExchangeType.ANYCOIN:
        return <AnycoinLogo width={"120px"} height={"30px"} {...props} />;
      case ExchangeType.COINMATE:
        return <CoinmateLogo width={"70px"} height={"40px"} color={colors.coinmateWordmark} {...props} />;
      case ExchangeType.BYBITEU:
        return <BybitEuLogo width={"90px"} height={"30px"} {...props} />;
      case ExchangeType.COINBASEPRO:
        return <CoinbaseproLogo width={"120px"} height={"30px"} {...props} />;
      case ExchangeType.BINANCE:
        return <BinanceLogo width={"112px"} height={"30px"} {...props} />;
      case ExchangeType.BITSTAMP:
        return <BitstampLogo width={"87px"} height={"30px"} {...props} />;
    }
  };

  return getIcon();
};

export default ExchangeIcon;
